document.addEventListener('DOMContentLoaded' , () => {
    const slider = document.querySelector('.info-slider');
    const sliderPagination = slider.querySelector('.swiper-pagination');
    const sliderNavigationNext = slider.querySelector('.buttons .swiper-button-next');
    const sliderNavigationPrev = slider.querySelector('.buttons .swiper-button-prev');

    const paginationObj = {
        el: sliderPagination,
        clickable: true
    }

    const navigationObj = {
        nextEl: sliderNavigationNext,
        prevEl: sliderNavigationPrev,
    };

    const autoplayObj = {
        delay: 3000,
        pauseOnMouseEnter: true
    };

    const sliderObj = new Swiper(".info-slider", {
        loop: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 20,
        navigation: navigationObj,
        pagination: paginationObj,
        autoplay: autoplayObj
    });

    
    console.log(sliderObj);
})
